import type { ScheduleTranslation } from './schedule.en'

export const scheduleFrCa: ScheduleTranslation = {
  common: {
    after: `Après`,
    cancel: `Annuler`,
    clear: `Effacer`,
    closed: `Fermé`,
    create: `Créer`,
    daily: `Quotidien`,
    delete: `Supprimer`,
    deleteError: {
      inUseGeneric: `Cet horaire ne peut pas être supprimé parce qu'il est utilisé par un standard. Retirez-le du standard puis réessayez.`,
      inUseMultiple: `Cet horaire ne peut pas être supprimé parce qu'il est utilisé dans ces standards : {{switchboardNames}}. Retirez-le de ces standards puis réessayez.`,
      inUseSingle: `Cet horaire ne peut pas être supprimé parce qu'il est utilisé dans ce standard : {{switchboardNames}}. Retirez-le de ce standard puis réessayez.`,
      listWithMore: `{{visibleNames}}, et {{remaining}} de plus`,
    },
    description: `Description`,
    edit: `Modifier`,
    from: `de`,
    holiday: `Férié`,
    monthly: `Mensuel`,
    name: `Nom`,
    never: `Jamais`,
    onDate: `À la date`,
    routing: `Routage`,
    save: `Enregistrer`,
    saving: `Enregistrement...`,
    timeZone: `Fuseau horaire`,
    to: `à`,
    validationErrorTitle: `Erreur de validation`,
    weekdayShort: {
      fri: `Ven`,
      mon: `Lun`,
      sat: `Sam`,
      sun: `Dim`,
      thu: `Jeu`,
      tue: `Mar`,
      wed: `Mer`,
    },
    weekdayLong: {
      fri: `Vendredi`,
      mon: `Lundi`,
      sat: `Samedi`,
      sun: `Dimanche`,
      thu: `Jeudi`,
      tue: `Mardi`,
      wed: `Mercredi`,
    },
    weekly: `Hebdomadaire`,
    yearly: `Annuel`,
  },
  detail: {
    actions: {
      deleteScheduleModalTitle: `Supprimer l'horaire`,
      deleteScheduleTitle: `Supprimer l'horaire`,
      editScheduleTitle: `Modifier l'horaire`,
    },
    currentRouting: `Routage actuel :`,
    error: `Erreur`,
    header: {
      breadcrumbCurrent: `Modifier les horaires`,
      breadcrumbRoot: `Horaires`,
    },
    hoursView: {
      calendar: `Calendrier`,
      list: `Liste`,
    },
    loading: `Chargement de l'horaire...`,
    notFound: {
      description: `L'horaire que vous recherchez n'existe pas.`,
      title: `Horaire introuvable`,
    },
    toast: {
      createOverrideFailedTitle: `Échec de la création de la dérogation`,
      createWeeklyHoursFailedTitle: `Échec de la création des heures hebdomadaires`,
      deleteEventFailedTitle: `Échec de la suppression de l'événement`,
      deleteScheduleFailedTitle: `Échec de la suppression de l'horaire`,
      eventDeleted: `Événement supprimé avec succès`,
      eventsUpdatedDescription: `Fuseau horaire mis à jour pour {{count}} événement(s)`,
      eventsUpdatedTitle: `Événements mis à jour`,
      failedTitle: `Échec`,
      genericError: `Une erreur s'est produite`,
      holidaysAddFailed: `Échec de l'ajout de {{count}} jour(s) férié(s)`,
      holidaysAddedSuccess: `{{count}} jour(s) férié(s) ajouté(s) avec succès`,
      holidaysAddedWithFailures: `{{successCount}} jour(s) férié(s) ajouté(s) avec succès ({{errorCount}} échec(s))`,
      loadEventsFailedDescription: `Une erreur s'est produite lors du chargement des événements`,
      loadEventsFailedTitle: `Échec du chargement des événements d'horaire`,
      loadScheduleFailedDescription: `Une erreur s'est produite lors du chargement de l'horaire`,
      loadScheduleFailedTitle: `Échec du chargement de l'horaire`,
      overrideCreated: `Dérogation créée avec succès`,
      overrideUpdated: `Dérogation mise à jour avec succès`,
      scheduleDeleted: `Horaire supprimé avec succès`,
      scheduleUpdated: `Horaire mis à jour avec succès`,
      successTitle: `Succès`,
      updateOverrideFailedTitle: `Échec de la mise à jour de la dérogation`,
      updateScheduleFailedTitle: `Échec de la mise à jour de l'horaire`,
      updateWeeklyHoursFailedTitle: `Échec de la mise à jour des heures hebdomadaires`,
      weeklyHoursCreated: `Heures hebdomadaires créées avec succès`,
      weeklyHoursUpdated: `Heures hebdomadaires mises à jour avec succès`,
    },
  },
  holidays: {
    actions: {
      addWithCount: `Ajouter des jours fériés ({{count}})`,
    },
    common: {
      unknown: `Inconnu`,
    },
    customPrompt: {
      link: `Configurez vos propres horaires spéciaux`,
      prefix: `Vous ne voyez pas le jour férié recherché ?`,
    },
    empty: `Aucun jour férié prédéfini disponible`,
    error: {
      failedToLoad: `Échec du chargement des jours fériés`,
    },
    loading: `Chargement des jours fériés...`,
    modal: {
      description: `Sélectionnez les jours fériés prédéfinis que vous souhaitez ajouter à votre liste de dérogations. Vous pourrez ajuster les heures de chaque jour férié en modifiant l'événement après sa création.`,
      title: `Ajouter des jours fériés prédéfinis`,
    },
    submitting: `Mise à jour de votre horaire, cela prendra seulement un instant.`,
    table: {
      holiday: `Jour férié`,
      nextOccurrence: `Prochaine occurrence`,
    },
    validation: {
      noneSelectedDescription: `Veuillez sélectionner au moins un jour férié à ajouter`,
      noneSelectedTitle: `Aucun jour férié sélectionné`,
    },
  },
  list: {
    card: {
      lastUpdated: `Dernière mise à jour`,
    },
    common: {
      notAvailable: `N/D`,
    },
    delete: `Supprimer`,
    deleteTitle: `Supprimer l'horaire`,
    empty: `Aucun horaire trouvé`,
    grid: {
      errorTitle: `Erreur`,
    },
    hoursVary: `Heures variables`,
    loading: `Chargement des horaires...`,
    newSchedule: `Nouvel horaire`,
    noPermission: `Vous n'avez pas l'autorisation d'accéder aux horaires.`,
    noSchedules: `Aucun horaire trouvé`,
    noSchedulesDescription: `Cliquez sur ajouter un nouvel horaire pour commencer à définir votre disponibilité`,
    pagination: {
      all: `Tous`,
      jumpToPage: `Aller à la page {{page}}`,
      nextPage: `Page suivante`,
      previousPage: `Page précédente`,
      resultsPerPage: `Résultats par page :`,
    },
    status: {
      closed: `Fermé`,
      holiday: `Férié`,
      openNow: `Ouvert maintenant`,
    },
    subtitle: `Voir et gérer les configurations d'horaires`,
    title: `Horaires`,
    toast: {
      createFailed: `Échec de la création`,
      createFailedDescription: `Échec de la création de l'horaire`,
      createSuccess: `Horaire créé`,
      createSuccessDescription: `L'horaire a été créé avec succès.`,
      deleteFailed: `Échec de la suppression`,
      deleteFailedDescription: `Échec de la suppression de l'horaire`,
      deleteSuccess: `Horaire supprimé`,
      deleteSuccessDescription: `L'horaire a été supprimé avec succès.`,
    },
    unavailable: `Indisponible`,
  },
  modal: {
    create: {
      cancel: `Annuler`,
      defaultWeeklyHoursLabel: `Inclure les heures hebdomadaires par défaut`,
      descriptionLabel: `Description`,
      descriptionPlaceholder: `Description facultative pour cet horaire`,
      nameLabel: `Nom`,
      namePlaceholder: `Heures d'ouverture`,
      saveSchedule: `Enregistrer l'horaire`,
      saving: `Enregistrement...`,
      timeZoneLabel: `Fuseau horaire`,
      title: `Nouvel horaire`,
      validationNameRequired: `Veuillez saisir un nom pour l'horaire`,
      validationTitle: `Validation`,
    },
    deleteConfirmation: {
      cancel: `Annuler`,
      confirm: `Supprimer`,
      defaultBodyWithItemPrefix: `Êtes-vous sûr de vouloir supprimer `,
      defaultBodyWithItemSuffix: ` ? Cette action est irréversible.`,
      defaultBodyWithoutItem: `Êtes-vous sûr de vouloir supprimer cet élément ? Cette action est irréversible.`,
      defaultTitle: `Supprimer l'élément`,
    },
    editSchedule: {
      applyTimezoneChanges: `Appliquer les changements de fuseau horaire à :`,
      customEventsHelp: `Décochez cette option si vous ne souhaitez pas mettre à jour le fuseau horaire des événements personnalisés existants.`,
      customEventsWithCount: `Événements personnalisés ({{count}})`,
      descriptionPlaceholder: `Description facultative pour cet horaire`,
      namePlaceholder: `Heures d'ouverture`,
      timezoneWarning: `Cela mettra à jour vos heures hebdomadaires selon le fuseau horaire sélectionné.`,
      title: `Modifier l'horaire`,
      updateSchedule: `Mettre à jour l'horaire`,
      validation: {
        nameRequired: `Veuillez saisir un nom pour l'horaire`,
      },
    },
    override: {
      dateTime: `Date et heure`,
      dateType: {
        multipleDays: `Plusieurs jours`,
        singleDay: `Un seul jour`,
      },
      endRepeat: `Fin de répétition`,
      irregularRepeat: `Cette dérogation a des modèles de répétition irréguliers et ne peut pas être modifiée`,
      irregularRepeatNamed: `{{name}} a un modèle de répétition qui ne peut pas être modifié.`,
      irregularRepeatNextOccurrence: `La prochaine occurrence est {{occurrence}}`,
      holidayTemplateCheckPending: `Vérification du modèle de répétition de {{name}}. Les contrôles de date et de répétition sont temporairement indisponibles.`,
      holidayTemplateCheckUnavailable: `Le modèle de répétition de {{name}} n'a pas pu être vérifié. Les contrôles de date et de répétition sont indisponibles.`,
      loadingDetails: `Chargement des détails de la dérogation...`,
      monthly: {
        nthWeekday: `Le {{nth}}{{suffix}} {{weekday}}`,
        specificDate: `Le {{day}}{{suffix}}`,
      },
      namePlaceholder: `Nom de la dérogation`,
      startTimeAriaLabel: `Heure de début`,
      startDateAriaLabel: `Date de début`,
      endDateAriaLabel: `Date de fin`,
      endRepeatDateAriaLabel: `Date de fin de répétition`,
      endTimeAriaLabel: `Heure de fin`,
      timePlaceholder: `h:mm`,
      meridiemAriaLabel: `{{label}} : a.m./p.m.`,
      meridiemOptionsAriaLabel: `{{label}} : options a.m./p.m.`,
      timeOptionsAriaLabel: `{{label}} : options`,
      occurrences: `occurrences`,
      repeat: `Répéter`,
      repeatEvery: `Répéter tous les`,
      repeatOn: `Répéter le`,
      repeatUnit: {
        days: `jour(s)`,
        months: `mois`,
        weeks: `semaine(s)`,
        years: `année(s)`,
      },
      timeType: {
        closedAllDay: `Fermé toute la journée`,
        setClosedHours: `Définir les heures fermées`,
      },
      titleCreate: `Ajouter une dérogation`,
      titleEdit: `Modifier la dérogation d'horaire`,
      validation: {
        endAfterStart: `La date/heure de fin doit être après la date/heure de début`,
        endDateRequired: `Veuillez sélectionner une date de fin pour les événements sur plusieurs jours`,
        endDateRequiredShort: `Veuillez sélectionner une date de fin`,
        invalidDateTime: `Veuillez saisir des valeurs de date et d'heure valides`,
        monthRequired: `Veuillez sélectionner un mois pour la répétition annuelle`,
        monthlyPatternRequired: `Veuillez sélectionner un modèle de répétition mensuel`,
        nameRequired: `Veuillez saisir un nom pour la dérogation`,
        occurrencesRequired: `Veuillez saisir le nombre d'occurrences`,
        startEndTimeRequired: `Veuillez sélectionner l'heure de début et de fin`,
        validDayRequired: `Veuillez sélectionner un jour valide (1-31)`,
        validWeekdayPatternRequired: `Veuillez sélectionner un modèle de jour de semaine valide`,
        weekdayRequired: `Veuillez sélectionner au moins un jour de la semaine`,
      },
      yearly: {
        nthWeekday: `Le {{nth}}{{suffix}} {{weekday}} de {{month}}`,
        specificDate: `Le {{day}}{{suffix}} de {{month}}`,
      },
    },
  },
  overrides: {
    actions: {
      addHoliday: `Ajouter un jour férié`,
      addOverride: `Ajouter une dérogation`,
    },
    empty: `Aucune dérogation d'horaire configurée`,
    item: {
      deleteHolidayTitle: `Supprimer le jour férié`,
      deleteOverrideModalTitle: `Supprimer la dérogation`,
      deleteOverrideTitle: `Supprimer la dérogation`,
      editOverrideTitle: `Modifier la dérogation`,
      overrideInEffect: `Dérogation en vigueur`,
      repeatsPrefix: `Répète`,
    },
    title: `Dérogations d'horaire`,
  },
  status: {
    closed: `Fermé`,
    holiday: `Férié`,
    open: `Ouvert`,
  },
  weeklyHours: {
    calendar: {
      confirmCreateDescription: `Créer une nouvelle entrée d'horaire pour cette plage horaire sélectionnée ?`,
      confirmCreateTitle: `Créer une entrée d'horaire`,
      confirmDeleteTitle: `Supprimer la plage horaire`,
      deleteEventLabel: `Supprimer {{day}} {{time}}`,
    },
    table: {
      confirmDeleteDayDescription: `Êtes-vous sûr de vouloir supprimer toutes les plages horaires de {{day}} ? Cette action est irréversible.`,
      confirmDeleteDayItem: `heures hebdomadaires de {{day}}`,
      confirmDeleteDayTitle: `Supprimer la plage horaire`,
      confirmDeleteSlotItem: `plage horaire de {{day}}`,
      confirmDeleteSlotTitle: `Supprimer la plage horaire`,
      days: {
        friday: `Vendredis`,
        monday: `Lundis`,
        saturday: `Samedis`,
        sunday: `Dimanches`,
        thursday: `Jeudis`,
        tuesday: `Mardis`,
        wednesday: `Mercredis`,
      },
      slot: {
        addTitle: `Ajouter une entrée d'horaire`,
        addDayLabel: `Ajouter des heures le {{day}}`,
        deleteTitle: `Supprimer une entrée d'horaire`,
        deleteSlotLabel: `Supprimer les heures du {{day}} de {{start}} à {{end}}`,
        endPlaceholder: `Fin`,
        startPlaceholder: `Début`,
        startTimeLabel: `Heure de début du {{day}}`,
        startTimeLabelNumbered: `Heure de début du {{day}}, entrée {{number}}`,
        endTimeLabel: `Heure de fin du {{day}}`,
        endTimeLabelNumbered: `Heure de fin du {{day}}, entrée {{number}}`,
        unavailable: `Indisponible`,
      },
      toggle: {
        disableDay: `Désactiver {{day}}`,
        enableDay: `Activer {{day}}`,
      },
    },
    timeSelect: {
      noTimesFound: `Aucune heure trouvée`,
    },
  },

  queryError: {
    fetchSchedules: `Échec du chargement des horaires`,
    fetchSchedule: `Échec du chargement de l'horaire`,
    fetchEvents: `Échec du chargement des événements de l'horaire`,
    fetchHolidays: `Échec du chargement des jours fériés de l'horaire`,
    createSchedule: `Échec de la création de l'horaire`,
    updateSchedule: `Échec de la mise à jour de l'horaire`,
    createEvent: `Échec de la création de l'événement d'horaire`,
    updateEvent: `Échec de la mise à jour de l'événement d'horaire`,
    deleteEvent: `Échec de la suppression de l'événement d'horaire`,
    generic: `Une erreur s'est produite. Veuillez réessayer.`,
  },
}
